module.exports = __webpack_public_path__ + "img/P62-en.5b303d3b.png";